const translations = {
  // Navbar
  nav_services: 'Services',
  nav_industries: 'Industries',
  nav_pricing: 'Pricing',
  nav_faq: 'FAQ',
  nav_testimonials: 'Testimonials',
  nav_contact: 'Contact',
  nav_login: 'Sign In',
  nav_register: 'Sign Up',
  nav_demo: 'Book a Consultation',
  theme_dark: 'Dark',
  theme_light: 'Light',
  // Hero
  hero_badge: 'Ideas that adapt · Innovation that transforms',
  hero_headline_1: 'Manage More.',
  hero_headline_2: 'Grow Without Limits.',
  hero_sub: 'Management systems, mobile apps, websites and custom software for businesses that want to automate, grow and scale.',
  hero_cta_demo: 'Book Your Free Appointment',
  hero_cta_services: 'See Solutions',
  hero_already_client: 'Already a client? Sign in',
  stat_availability: 'Uptime',
  stat_install: 'Setup Time',
  stat_support: 'Support',
  // Benefits
  benefits_label: 'Key Benefits',
  benefits_title_1: 'Three pillars of',
  benefits_title_2: 'success',
  benefit_auto_title: 'Full Automation',
  benefit_auto_p1: 'Automatic invoices and receipts',
  benefit_auto_p2: 'Reports without manual effort',
  benefit_auto_p3: 'Smart stock alerts',
  benefit_auto_p4: 'Zero data entry errors',
  benefit_ctrl_title: 'Total Control',
  benefit_ctrl_p1: 'Real-time sales dashboard',
  benefit_ctrl_p2: 'Multi-branch management',
  benefit_ctrl_p3: 'Staff performance tracking',
  benefit_ctrl_p4: 'P&amp;L in real time',
  benefit_growth_title: 'Accelerated Growth',
  benefit_growth_p1: 'Sales trends',
  benefit_growth_p2: 'Revenue leak detection',
  benefit_growth_p3: 'Customer retention',
  benefit_growth_p4: 'Scale without switching systems',
  // WhyInnoflex
  why_label: 'Why Choose Us?',
  why_title: 'The technology partner your',
  why_title_accent: 'deserves',
  why_title_mid: 'business',
  why_sub: 'ERP, POS, accounting and e-invoicing in a single system. Specialized software design and development adapted exactly to the way you operate.',
  why_r1_title: 'Live in 48h',
  why_r1_desc: 'Up and running in two days, not weeks.',
  why_r2_title: 'Secure & Reliable',
  why_r2_desc: 'Enterprise encryption. 99.9% uptime guaranteed.',
  why_r3_title: 'Real Support',
  why_r3_desc: 'WhatsApp, phone or email — whenever you need us.',
  why_r4_title: 'Proven ROI',
  why_r4_desc: '+8 hours saved weekly. 90% fewer errors.',
  why_r5_title: 'Customizable',
  why_r5_desc: 'Adapts to your workflow. Not the other way around.',
  why_r6_title: 'No IT Needed',
  why_r6_desc: 'Intuitive from day one. We handle the technical side.',
  why_stat_errors: 'Fewer errors',
  why_stat_hours: 'Saved/week',
  why_stat_setup: 'Setup',
  why_stat_support: 'Support',
  // Services
  services_label: 'Our Services',
  services_title_1: 'Design, Development &',
  services_title_accent: 'Smart Solutions',
  services_sub: 'Four service pillars — management systems, mobile apps, websites and tech consulting. All under one team.',
  services_f1_title: 'Financial Control',
  services_f1_i1: 'Sales, expenses & P&L',
  services_f1_i2: 'Real-time reports',
  services_f2_title: 'Smart Inventory',
  services_f2_i1: 'Live stock control',
  services_f2_i2: 'Automatic restock alerts',
  services_f3_title: 'DGII Billing',
  services_f3_i1: 'Certified E-CF',
  services_f3_i2: 'Automatic documents & receipts',
  services_f4_title: 'Operations Management',
  services_f4_i1: 'Registers, staff & shifts',
  services_f4_i2: 'Purchases & suppliers',
  services_f5_title: 'Universal Access',
  services_f5_i1: 'Any device',
  services_f5_i2: 'Works offline',
  services_f6_title: 'Advanced Suite',
  services_f6_i1: 'Appointment system',
  services_f6_i2: 'WhatsApp Bot + Digital catalog',
  services_badge_exclusive: 'EXCLUSIVE',
  services_custom_label: 'Custom Development',
  services_custom_title_1: "We don't sell software.",
  services_custom_title_2: 'We build solutions.',
  services_custom_sub: 'Technology that adapts to the way you work.',
  services_custom_i1: '100% adaptable system',
  services_custom_i2: 'Full customization',
  services_custom_i3: 'Scales with you',
  services_custom_i4: 'Apps & web platforms',
  services_whatsapp_cta: 'Talk to an advisor',
  // Services — 4 Pillars
  services_p1_title: 'Management Systems',
  services_p1_sub: 'ERP, POS and integrated accounting — complete software to operate and automate your business with full control',
  services_p1_f1: 'Certified DGII electronic billing',
  services_p1_f2: 'Real-time inventory control',
  services_p1_f3: 'Registers (POS), employees & advanced reports',
  services_p1_f4: 'Multi-branch · Works offline',
  services_p1_for: 'Ideal for:',
  services_p1_tag1: 'Restaurants',
  services_p1_tag2: 'Supermarkets',
  services_p1_tag3: 'Hardware Stores',
  services_p1_tag4: 'Dealers / ERP',
  services_p2_title: 'Mobile Apps',
  services_p2_sub: 'iOS and Android applications built from scratch for your business',
  services_p2_f1: 'Modern, custom UX/UI design',
  services_p2_f2: 'Integration with APIs and existing systems',
  services_p2_f3: 'App Store & Google Play publishing',
  services_p2_f4: 'Scalable, secure cloud backend',
  services_p2_for: 'Technologies:',
  services_p2_tag1: 'iOS & Android',
  services_p2_tag2: 'React Native',
  services_p2_tag3: 'Flutter',
  services_p3_title: 'Websites',
  services_p3_sub: 'Professional digital presence that turns visitors into real customers',
  services_p3_f1: 'Modern responsive custom design',
  services_p3_f2: 'Landing pages, corporate sites & e-commerce',
  services_p3_f3: 'SEO-optimized from the start',
  services_p3_f4: 'Speed, hosting and domain managed',
  services_p3_for: 'Types:',
  services_p3_tag1: 'Landing Pages',
  services_p3_tag2: 'E-commerce',
  services_p3_tag3: 'Portfolios',
  services_p4_title: 'Consulting',
  services_p4_sub: 'Technology strategy to digitalize and scale your business',
  services_p4_f1: 'Full audit of processes and systems',
  services_p4_f2: 'Personalized digitalization roadmap',
  services_p4_f3: 'Tool selection and integration',
  services_p4_f4: 'Post-project support and follow-up',
  services_p4_for: 'For:',
  services_p4_tag1: 'Startups',
  services_p4_tag2: 'SMBs',
  services_p4_tag3: 'Enterprises',
  services_cta_heading: 'Every solution, designed exactly for you',
  services_cta_desc: "We don't sell templates. We understand your business, identify what you need and build the perfect solution — no complications.",
  services_cta_ask: 'Talk to an advisor',
  services_cta_book: 'Book Your Free Appointment',
  // Industries
  industries_label: 'Industries we serve',
  industries_title_1: 'Designed for your',
  industries_title_accent: 'type of business',
  industries_sub: "No matter what you sell — we have a solution for you.",
  industries_see: 'See solution',
  ind_1_title: 'Restaurants',
  ind_1_desc: 'Tables, orders and billing all in one place.',
  ind_1_stat: '↑ 40% efficiency',
  ind_2_title: 'Supermarkets',
  ind_2_desc: 'Fast checkout, real inventory and daily reports.',
  ind_2_stat: '↑ 3x speed',
  ind_3_title: 'Hardware Stores',
  ind_3_desc: 'Thousands of products, instant invoices.',
  ind_3_stat: '↓ 90% errors',
  ind_4_title: 'Minimarkets',
  ind_4_desc: 'Fast to set up, easy to use.',
  ind_4_stat: '48h setup',
  ind_5_title: 'Dealers',
  ind_5_desc: 'ERP, accounting, POS and full control for your dealership.',
  ind_5_stat: '↑ 60% control',
  ind_6_title: 'Loan Agencies',
  ind_6_desc: 'Clients, payments and installments with full precision.',
  ind_6_stat: '24/7 access',
  // Testimonials
  test_label: 'Success Stories',
  test_title_1: 'Businesses that',
  test_title_accent: 'made the leap',
  test_sub: 'Real people, real businesses. Here\'s what those who already use InnoFlex every day have to say.',
  test_1_role: 'Owner',
  test_1_company: 'Liwama Autoimport',
  test_1_industry: 'Automotive',
  test_1_quote: 'I used to manage everything with papers and notebooks. Since we implemented InnoFlex I have full control of sales, parts inventory and customer accounts in one place. Electronic billing makes everything easier with the DGII.',
  test_2_role: 'Owner',
  test_2_company: "Liesca's Parties",
  test_2_industry: 'Events',
  test_2_quote: 'The appointment system and WhatsApp bot completely changed our operation. Clients used to call and there was confusion about events. Now everything is booked automatically, there\'s never a double reservation, and sales went up because we handle more organized clients.',
  test_3_role: 'Owner',
  test_3_company: 'Minimarket Doña Negra',
  test_3_industry: 'Minimarket',
  test_3_quote: 'I had everything written on paper and always lost track of inventory. Since I started using InnoFlex I know exactly what comes in and goes out. The stock alerts have saved me from running out of products several times. I recommend it to any store owner.',
  test_4_role: 'Owner',
  test_4_company: 'Spartech Computadoras',
  test_4_industry: 'Technology',
  test_4_quote: 'Selling equipment, accessories and providing tech support at the same time was complicated to manage. InnoFlex lets me track repairs, warranties and inventory, and bill electronically without complications. It gave my business a professional edge.',
  // Pricing
  pricing_label: 'Pricing',
  pricing_title_1: 'Choose the plan that',
  pricing_title_accent: 'fits you',
  pricing_sub: 'No surprises or fine print. Every plan includes setup, training and the exact tools your business needs.',
  pricing_billing_note: 'Plans exclusively for the Billing System',
  pricing_other_services: 'Apps, websites or consulting → price per project',
  pricing_monthly: 'Monthly',
  pricing_annual: 'Annual',
  pricing_cards: 'Plans',
  pricing_compare: 'Compare',
  pricing_note: 'All plans include setup, configuration and initial training',
  pricing_impl: 'setup — one-time fee',
  pricing_save: 'You save',
  pricing_usd_month: 'USD/mo',
  pricing_view_more: 'View more',
  pricing_view_less: 'View less',
  pricing_badge_popular: 'Most Popular',
  pricing_badge_max: 'Maximum Power',
  plan_starter_tagline: 'Start off on the right foot',
  plan_business_tagline: 'The favorite of growing businesses',
  plan_pro_tagline: 'For businesses that want everything included',
  plan_premium_tagline: 'The system that grows with your business',
  plan_starter_cta: 'Choose Starter',
  plan_business_cta: 'Choose Business',
  plan_pro_cta: 'Choose Pro',
  plan_premium_cta: 'Choose Premium',
  compare_feature_col: 'Feature',
  pf_repair_log: 'Repair log',
  pf_credits: 'Credit / loan module',
  pf_includes_premium: 'Includes full Premium plan',
  pf_custom_modules: '100% custom modules',
  pf_exclusive_features: '100% exclusive features',
  pf_support_starter_detail: 'Email · Response 24–48h · No real-time support',
  pf_support_business_detail: 'Chat M-F 9am–6pm · Response 8–24h · Medium priority',
  pf_support_pro_detail: 'Chat + WhatsApp 7am–12am · Response 2–6h · Priority support',
  pf_support_premium_detail: 'Email, VIP Chat, WhatsApp, Phone · 24/7 · < 1h',
  pf_support_custom_detail: 'Dedicated SLA · Direct contact · 24/7 · < 1h',
  pf_billing_basic: 'Basic billing',
  pf_inventory: 'Inventory control',
  pf_1_register: '1 cash register',
  pf_multi_register: 'Multiple cash registers',
  pf_reports_basic: 'Basic sales reports',
  pf_reports_adv: 'Advanced financial reports',
  pf_mobile: 'Mobile access',
  pf_employees: 'Employee & shift management',
  pf_purchases: 'Purchases & suppliers',
  pf_dgii: 'Certified DGII e-invoicing',
  pf_appointments: 'Integrated appointment system',
  pf_whatsapp_bot: 'WhatsApp bot integration',
  pf_catalog: 'Digital catalog sales',
  pf_multistore: 'Multi-store management',
  pf_analytics: 'Advanced sales analytics',
  pf_custom_hours: '5 hrs/month system modifications',
  pf_custom_funcs: 'Custom business features',
  pf_consulting: 'Monthly tech consulting',
  pf_support_email: 'M–F email support',
  pf_support_247: '24/7 WhatsApp support',
  pf_support_priority: '24/7 priority support',
  pf_support_dedicated: 'Dedicated 24/7 priority support',
  pf_includes_starter: 'Includes full Starter plan',
  pf_includes_business: 'Includes full Business plan',
  pf_includes_pro: 'Includes full Pro plan',
  pf_training: 'Continuous team training',
  pf_onboarding: 'Extended personalized onboarding',
  pf_early_access: 'Early access to new features',
  pf_monthly_review: 'Monthly performance review',
  pf_integrations: 'Custom integration development',
  // ── Plan limits pills ──────────────────────────────────────────
  plan_starter_l1: '1 User',
  plan_starter_l2: '1 POS Register',
  plan_starter_l3: '1 Warehouse',
  plan_starter_l4: 'No e-CF invoices',
  plan_starter_l5: '1 Branch',
  plan_starter_l6: 'Email support',

  plan_business_l1: '3 Users',
  plan_business_l2: '3 POS Registers',
  plan_business_l3: '2 Warehouses',
  plan_business_l4: '100 invoices/mo',
  plan_business_l5: '1 Branch',
  plan_business_l6: 'Chat M-F 9am-6pm',

  plan_pro_l1: '8 Users',
  plan_pro_l2: '5 POS Registers',
  plan_pro_l3: '5 Warehouses',
  plan_pro_l4: '150 invoices/mo',
  plan_pro_l5: '2 Branches',
  plan_pro_l6: 'Priority support (1-4h)',

  plan_premium_l1: '∞ Users',
  plan_premium_l2: '∞ POS Registers',
  plan_premium_l3: '∞ Warehouses',
  plan_premium_l4: '200 invoices/mo',
  plan_premium_l5: '∞ Branches',
  plan_premium_l6: 'Dedicated support',

  plan_custom_l1: '∞ Users',
  plan_custom_l2: '∞ POS Registers',
  plan_custom_l3: '∞ Warehouses',
  plan_custom_l4: 'Custom invoices',
  plan_custom_l5: '∞ Branches',
  plan_custom_l6: 'Dedicated SLA',

  plan_custom_tagline: 'A system 100% designed for your operation',
  plan_custom_cta: 'Get a Quote',
  plan_custom_price: 'Quote',
  pricing_badge_custom: 'Custom',

  // ── Compare table – limits section ────────────────────────────
  compare_group_limits: 'Plan Limits',
  compare_lim_users: 'Users',
  compare_lim_cajas: 'POS Registers',
  compare_lim_warehouses: 'Warehouses',
  compare_lim_invoices: 'Invoices / month',
  compare_lim_branches: 'Branches',
  compare_lim_support: 'Support type',
  // FAQ
  faq_label: 'Frequently Asked Questions',
  faq_title_1: 'We answer your',
  faq_title_2: 'questions',
  faq_sub: 'Everything you need to know before taking the next step. If your question isn\'t here, reach out directly.',
  faq_cat_sub: 'Select a category and find the answer you need.',
  faq_questions: 'questions',
  faq_bottom_title: 'Have another question?',
  faq_bottom_sub: 'Our team replies in minutes.',
  faq_bottom_cta: 'Contact Us',
  // FAQ Categories
  faq_cat_sistema: 'The System',
  faq_cat_implementacion: 'Implementation',
  faq_cat_facturacion: 'Billing',
  faq_cat_desarrollo: 'Development',
  faq_cat_planes: 'Plans & Pricing',
  faq_cat_digital_dev: 'Apps & Webs',
  faq_cat_republicafel: 'RepublicaFEL',
  // FAQ - The System
  faq_s1_q: 'What does InnoFlex include?',
  faq_s1_a: 'Electronic billing, inventory control, register and employee management, real-time financial reports, mobile access, appointment system, WhatsApp bot and digital catalog sales — all in one platform.',
  faq_s2_q: 'Does it work without internet?',
  faq_s2_a: 'Yes. InnoFlex operates in offline mode. You can keep selling and billing without a connection. Data syncs automatically when the signal returns.',
  faq_s3_q: 'What devices can I use to access it?',
  faq_s3_a: 'Any device: phone, tablet, laptop or desktop. You only need a browser or the app — no complex installations.',
  // FAQ - Implementation
  faq_i1_q: 'How long does setup take?',
  faq_i1_a: 'In 48 hours your system is live and your team is trained. We handle all the technical setup — you just focus on your business.',
  faq_i2_q: 'Do you only work in the Dominican Republic?',
  faq_i2_a: 'Our main base is in DR, but we work with businesses across Latin America remotely without any problem.',
  // FAQ - Billing
  faq_f1_q: 'Are you certified for electronic billing?',
  faq_f1_a: 'Yes. We have a certified electronic billing provider, fully complying with all DGII fiscal regulations without extra complications.',
  faq_f2_q: 'What fiscal documents does the system generate?',
  faq_f2_a: 'E-CF (Electronic Fiscal Receipt), credit and debit notes, payment receipts and all documents required by the DGII — generated automatically with each transaction.',
  faq_f3_q: 'What does the e-CF Certification with RepublicaFEL include?',
  faq_f3_a: 'e-CF Certification via InnoFlex costs $300 (one-time). It includes RepublicaFEL portal activation, full e-CF setup with the DGII and activation support — $150 less than going directly with RepublicaFEL ($450). If you take the Full Bundle, the certification drops to $250 within the $450 total package.',
  faq_f4_q: 'What is the RepublicaFEL Portal and what is it for?',
  faq_f4_a: 'The RepublicaFEL Portal is our official e-invoicing partner\'s web platform. From that portal you can look up all your issued e-CFs, manage your NCF codes, view your fiscal receipt history and track transactions directly with the DGII. It is the perfect complement for an ERP or management system like InnoFlex.',
  // FAQ - Development
  faq_d1_q: 'Do you also do custom software development?',
  faq_d1_a: 'Absolutely. InnoFlex is a full software design and development company. We build mobile apps, internal systems, web platforms and more — all tailored exactly to your business.',
  faq_d2_q: 'What if I need more features?',
  faq_d2_a: 'InnoFlex scales with you. You can add modules, branches or custom features at any time without switching platforms.',
  // FAQ - Plans & Pricing
  faq_p1_q: 'Does the price include updates and support?',
  faq_p1_a: 'Yes. The monthly fee includes the full system, automatic updates, support according to your plan and access to new features at no extra cost.',
  faq_p2_q: 'Can I try the system before paying?',
  faq_p2_a: 'Yes. Free personalized demo with no commitment or credit card required. Book directly on the calendar and in 1 hour we\'ll show you everything.',
  // FAQ - Digital Development (Apps & Webs)
  faq_dd1_q: 'How long does it take to build a mobile app or website?',
  faq_dd1_a: 'It depends on the project scope. A landing page or corporate site can be ready in 1–2 weeks. A full mobile app takes between 6 and 16 weeks depending on the features. We always provide a detailed timeline before we start.',
  faq_dd2_q: 'What technologies do you use for apps and websites?',
  faq_dd3_a: 'For mobile apps we use React Native and Flutter (native iOS & Android). For websites we use React, Next.js and modern stacks with technical SEO built in. For backends, Node.js, cloud databases and REST or GraphQL APIs as needed.',
  faq_dd4_q: 'Can I request changes or new features after launch?',
  faq_dd4_a: 'Yes. We offer maintenance and continuous development contracts for all projects. You can also purchase additional modification hours on demand. Your product grows alongside your business.',
  faq_dd5_q: 'Does it include hosting, domain and app store publishing?',
  faq_dd5_a: 'Yes. We handle hosting, domain configuration and deployment on cloud servers. For mobile apps, we manage the full submission to the App Store (Apple) and Google Play, including all review and approval steps.',
  // FAQ - RepublicaFEL
  faq_rfel1_q: 'What is RepublicaFEL?',
  faq_rfel1_a: 'RepublicaFEL is InnoFlex\'s official partner for electronic invoicing in the Dominican Republic. It is a DGII-certified provider that issues e-CFs (Electronic Fiscal Receipts), credit notes, debit notes and all fiscal documents required by law.',
  faq_rfel2_q: 'Do I need a separate RepublicaFEL account?',
  faq_rfel2_a: 'No need to handle it yourself. When you purchase e-CF Certification through InnoFlex ($300 or $250 in the Full Bundle), we activate your RepublicaFEL portal, configure it with the DGII and connect it directly to your InnoFlex system — all included.',
  faq_rfel3_q: 'How does the InnoFlex + RepublicaFEL integration work?',
  faq_rfel3_a: 'The integration is native and transparent. Every time you record a sale in InnoFlex, the e-CF is automatically generated and submitted to the DGII through the RepublicaFEL portal. You don\'t need to switch between systems — everything happens inside InnoFlex in real time.',
  faq_rfel4_q: 'What can I do in the RepublicaFEL Portal?',
  faq_rfel4_a: 'From the RepublicaFEL portal you can look up all your issued e-CFs, manage your NCF codes, view your fiscal receipt history and track transactions directly with the DGII. It is your official fiscal control panel, accessible at any time.',
  faq_rfel5_q: 'How much do I save by certifying via InnoFlex vs. going direct?',
  faq_rfel5_a: 'Going directly with RepublicaFEL costs $450. Through InnoFlex the certification is $300 (saving $150). With the Full Bundle (setup + e-CF + portal), e-CF drops to $250 within the $450 total — saving $200 vs. buying everything separately ($650).',
  // FinalCTA
  cta_title_1: 'Your next big move',
  cta_title_2: 'starts with an appointment',
  cta_sub: 'In 1 hour we\'ll talk about what your business needs. No commitment, no fine print.',
  cta_contact: 'Contact Us',
  cta_calendar: 'Book Your Free Appointment',
  cta_footer: 'No credit card · Setup in 48 hours',
  // Contact
  contact_label: 'Contact Us',
  contact_title_1: 'We\'re here',
  contact_title_2: 'to help you',
  contact_sub: 'Via WhatsApp, email or form — we\'re available to answer your questions and help you take the next step.',
  contact_whatsapp_sub: 'Immediate response',
  contact_email_title: 'Email',
  contact_address_title: 'Address',
  contact_form_title: 'Send Us a Message',
  contact_form_name: 'Full name',
  contact_form_phone: 'Phone',
  contact_form_email: 'Email address',
  contact_form_type: 'Business type',
  contact_form_msg: 'Message',
  contact_form_send: 'Send Message',
  contact_form_sending: 'Sending...',
  contact_success_title: 'Message received!',
  contact_success_sub: 'We\'ll get back to you very soon.',
  contact_error: 'Something went wrong. Please try again or contact us directly.',
  contact_select_placeholder: 'Select your industry...',
  // Plan Form Modal
  plan_form_selected: 'Selected plan',
  plan_form_title: 'Great! Tell us about your business',
  plan_form_sub: 'Fill in the form and an advisor will contact you very soon to activate your plan.',
  plan_form_name: 'Full name',
  plan_form_name_placeholder: 'Your full name',
  plan_form_phone: 'Phone',
  plan_form_phone_placeholder: '+1 (809) 000-0000',
  plan_form_email: 'Email address',
  plan_form_email_placeholder: 'you@email.com',
  plan_form_business: 'Business name',
  plan_form_business_placeholder: 'e.g. My Awesome Store',
  plan_form_type: 'Business type',
  plan_form_implementation: 'Implementation you need',
  plan_form_impl_standard: 'Standard Setup — $200',
  plan_form_impl_full_bundle: 'Full Bundle with e-CF — $450 (save $200)',
  plan_form_impl_fel_only: 'e-CF Certification Only — $300',
  plan_form_msg: 'Additional message (optional)',
  plan_form_msg_placeholder: 'Any questions or special details about your business?',
  plan_form_send: 'Send Request',
  plan_form_sending: 'Sending...',
  plan_form_success: 'Request sent successfully!',
  plan_form_success_sub: 'An InnoFlex advisor will contact you within 24 hours to coordinate your plan activation.',
  plan_form_error: 'Something went wrong. Please try again or reach out via WhatsApp.',
  plan_form_close: 'Close',
  plan_form_ind_restaurant: 'Restaurant / Food & Beverage',
  plan_form_ind_supermarket: 'Supermarket / Grocery',
  plan_form_ind_hardware: 'Hardware Store',
  plan_form_ind_minimarket: 'Minimarket / Grocery',
  plan_form_ind_distributor: 'Distributor / Dealer',
  plan_form_ind_loan: 'Loan Agency',
  plan_form_ind_events: 'Events / Entertainment',
  plan_form_ind_tech: 'Technology',
  plan_form_ind_other: 'Other',
  // Navbar tagline
  nav_tagline: 'Ideas that adapt · Innovation that transforms',
  // BookDemo
  book_label: 'Book Your Appointment',
  book_title_1: 'Book your',
  book_title_2: 'free session',
  book_sub: 'Choose the type of service you need and the time that works best. A specialist will be with you.',
  book_h1_text: 'System Demo',
  book_h1_sub: 'See the software live',
  book_h2_text: 'Consulting',
  book_h2_sub: 'Personalized tech advisory',
  book_h3_text: 'New Project',
  book_h3_sub: 'Custom development',
  book_h4_text: 'Website',
  book_h4_sub: 'Design & development',
  book_loading: 'Loading calendar...',
  book_fallback: 'Having trouble seeing the calendar?',
  book_fallback_link: 'Open it here',
  book_badge: 'Availability open now',
  book_cta_heading: 'Tell us what your business needs',
  book_cta_desc: 'Whether it\'s a system demo, tech consulting, a custom project or your first website — book your appointment and let\'s talk.',
  book_cta_btn: 'Book Your Free Appointment',
  book_cta_note: 'No credit card · No commitment · Instant response',
  book_steps_title: 'How does the booking work?',
  book_step1_title: 'Open the AI assistant',
  book_step1_desc: 'Click the button and the InnoFlex voice assistant opens. You can speak or type — it understands both.',
  book_step2_title: 'Tell it when you prefer',
  book_step2_desc: 'The agent checks real-time availability and locks in the slot automatically. No forms, no extra steps.',
  book_step3_title: 'Automatic confirmation',
  book_step3_desc: 'You\'ll receive a confirmation email instantly. The agent handles the entire process for you.',
  book_agent_note_title: '4 session types available',
  book_agent_note_desc: 'System demo, consulting, new project or website creation. Choose what best fits your needs.',
  book_social_title: '+50 appointments booked this month',
  book_social_sub: 'Companies from DR and Latin America trust InnoFlex',
  // Footer
  footer_desc: 'Smart billing software and custom technology solutions that help businesses automate, grow and maintain full control.',
  footer_contact_btn: 'Contact Us',
  footer_rights: 'All rights reserved.',
  footer_cat_solutions: 'Solutions',
  footer_cat_industries: 'Industries',
  footer_cat_company: 'Company',
  footer_l_billing: 'Billing Software',
  footer_l_custom: 'Custom Development',
  footer_l_consulting: 'Tech Consulting',
  footer_l_restaurants: 'Restaurants',
  footer_l_supermarkets: 'Supermarkets',
  footer_l_hardware: 'Hardware Stores',
  footer_l_distributors: 'Dealers',
  footer_l_industries_all: 'View all sectors',
  footer_l_why: 'Why InnoFlex?',
  footer_l_testimonials: 'Testimonials',
  footer_l_pricing: 'Pricing',
  footer_l_faq: 'FAQ',
  footer_l_contact: 'Contact',
  // Navbar blog
  nav_blog: 'Blog',
  // Footer blog
  footer_l_blog: 'Blog & Resources',
  // WhatsApp Float
  whatsapp_online: 'Online now',
  whatsapp_msg: 'Hi! 👋 Ready to automate your business? Write to us now.',
  whatsapp_chat: 'Chat now',
  // Contact select & placeholders
  contact_ind_restaurant: 'Restaurant',
  contact_ind_supermarket: 'Supermarket',
  contact_ind_hardware: 'Hardware Store',
  contact_ind_minimarket: 'Minimarket / Grocery',
  contact_ind_distributor: 'Distributor / Dealer',
  contact_ind_loan: 'Loan Agency',
  contact_ind_other: 'Other',
  contact_ph_name: 'John Doe',
  contact_ph_phone: '+1 809 000 0000',
  contact_ph_email: 'you@business.com',
  contact_ph_msg: 'Tell us about your business and what you need...',
  contact_form_request: 'Request type',
  contact_req_placeholder: 'Select what you need...',
  contact_req_demo: 'System Demo',
  contact_req_consulting: 'Tech Consulting',
  contact_req_full_bundle: 'Full Bundle with e-CF — $450',
  contact_req_fel_only: 'e-CF Certification Only — $300',
  contact_req_project: 'Custom Project',
  contact_req_website: 'Website',
  contact_req_other: 'Other',
  // Activation Process
  activation_label: 'Activation Process',
  activation_title_1: 'Up and running in',
  activation_title_2: '48 hours',
  activation_sub: 'No complications. Three simple steps and your business is already automated.',
  activation_step_label: 'Step',
  activation_step1_title: 'Choose Your Plan',
  activation_step1_desc: 'Pick the plan that best fits your business and budget. From basic to premium, there is one for every stage.',
  activation_step1_detail: 'From $19.99/mo',
  activation_step2_title: 'Tell Us About You',
  activation_step2_desc: 'Fill out the form with your business details. An advisor will contact you within 24 hours to coordinate everything.',
  activation_step2_detail: 'Response within 24h',
  activation_step3_title: 'Ready to Go',
  activation_step3_desc: 'We install, configure and train your team. Your system will be live, tested and ready in under two days.',
  activation_step3_detail: 'Live in 48 hours',
  activation_cta: 'Choose My Plan',
  activation_cta_note: 'No credit card · Setup in 48 hours',
  // BookingCalendar
  cal_step_date: 'Date',
  cal_step_time: 'Time',
  cal_step_form: 'Confirm',
  cal_prev: 'Previous month',
  cal_next: 'Next month',
  cal_no_slots: 'No time slots available for this day.',
  cal_back_date: 'Back to dates',
  cal_modify_time: 'Change time',
  cal_your_booking: 'Your booking',
  cal_date_label: 'Date',
  cal_time_label: 'Time',
  cal_name_label: 'Full name',
  cal_phone_label: 'Phone',
  cal_name_placeholder: 'Your full name',
  cal_phone_placeholder: '+1 (809) 000-0000',
  cal_submit: 'Confirm Appointment',
  cal_submitting: 'Confirming...',
  cal_success_title: 'Appointment booked successfully!',
  cal_success_msg: 'You\'ll receive a confirmation email shortly. See you soon!',
  cal_error: 'Could not confirm your appointment. Please try again or contact us via WhatsApp.',
  cal_loading: 'Loading availability...',
  cal_wd_sun: 'Sun',
  cal_wd_mon: 'Mon',
  cal_wd_tue: 'Tue',
  cal_wd_wed: 'Wed',
  cal_wd_thu: 'Thu',
  cal_wd_fri: 'Fri',
  cal_wd_sat: 'Sat',
  cal_m1: 'January',
  cal_m2: 'February',
  cal_m3: 'March',
  cal_m4: 'April',
  cal_m5: 'May',
  cal_m6: 'June',
  cal_m7: 'July',
  cal_m8: 'August',
  cal_m9: 'September',
  cal_m10: 'October',
  cal_m11: 'November',
  cal_m12: 'December',
  // BookingCalendar additions
  cal_biz_label: 'Business type',
  cal_biz_placeholder: 'Select your industry...',
  cal_biz_restaurant: 'Restaurant / Food & Beverage',
  cal_biz_supermarket: 'Supermarket / Grocery',
  cal_biz_hardware: 'Hardware Store',
  cal_biz_minimarket: 'Minimarket',
  cal_biz_distributor: 'Distributor',
  cal_biz_loan: 'Loan Agency',
  cal_biz_events: 'Events / Entertainment',
  cal_biz_tech: 'Technology',
  cal_biz_other: 'Other',
  cal_legend_available: 'Available',
  cal_legend_selected: 'Selected',
  cal_email_label: 'Email address',
  cal_email_placeholder: 'you@email.com',
  // New booking system keys
  cal_slot_duration: '1 hour · Personalized session',
  cal_session_limit: 'You already have an appointment booked in this session. To modify your booking, contact us via WhatsApp.',
  cal_success_email_msg: 'We sent a confirmation to {email}. See you soon!',
  cal_confirm_title: 'Your Appointment Summary',
  cal_confirm_date: 'Date',
  cal_confirm_time: 'Time',
  cal_confirm_name: 'Name',
  cal_confirm_phone: 'Phone',
  cal_confirm_email: 'Email',
  cal_confirm_biz: 'Business type',
  cal_confirm_note: 'Check your inbox (including spam folder). If you do not receive the confirmation within a few minutes, contact us via WhatsApp.',
  cal_confirm_new: 'Book another appointment',
  // Appointment mode
  cal_demo_mode_label: 'Session format',
  cal_demo_mode_remote: 'Remote · Video call',
  cal_demo_mode_in_person: 'In-person · On-site visit',
  cal_confirm_mode: 'Format',
  // Week urgency counter
  cal_slots_week_few: 'Only {n} slots left this week!',
  cal_slots_week_some: '{n} slots available this week',
  cal_slots_week_many: '{n} slots available this week',
  cal_urgency_last: 'Last available slot for this day!',
  cal_urgency_few: 'Only {n} slots left today!',
  cal_wa_notify_btn: 'Send booking details to team via WhatsApp',
  cal_phone_is_whatsapp: 'This number is on WhatsApp',
  // Appointment type
  cal_appt_type_label: 'Appointment type',
  cal_appt_type_placeholder: 'Select type...',
  cal_appt_demo: 'System Demo',
  cal_appt_consultoria: 'Consulting',
  cal_appt_proyecto: 'New Project',
  cal_appt_web: 'Website Creation',
  cal_appt_otro: 'Other',
  cal_confirm_appt_type: 'Appointment type',
  cal_appt_otro_placeholder: 'Briefly describe what you need or what type of service you are looking for...',
  // Partners
  partners_label: 'Strategic Alliances',
  partners_title_1: 'Our Official',
  partners_title_accent: 'Partners',
  partners_sub: 'We work hand-in-hand with the best providers to offer you a complete, integrated technology ecosystem.',
  partners_fel_name: 'República FEL',
  partners_fel_category: 'Official Partner · Electronic Invoicing',
  partners_fel_tagline: 'Certified electronic invoicing provider for the Dominican Republic',
  partners_fel_desc: 'RepublicaFEL is our official electronic invoicing partner. Their DGII-certified e-CF platform integrates natively with InnoFlex, letting you issue invoices, credit notes and all fiscal receipts from a single system.',
  partners_fel_tag1: 'DGII-Certified e-CF',
  partners_fel_tag2: 'Dedicated e-CF Portal',
  partners_fel_tag3: 'Native Integration',
  partners_fel_tag4: 'Local RD Support',
  partners_fel_cta: 'Learn about RepublicaFEL',
  partners_portal_btn: 'Access the Portal',
  partners_portal_desc: 'Look up your e-CFs, manage NCF codes and track your fiscal activity directly from the official portal.',
  // FEL Comparison
  fel_comp_title: 'InnoFlex vs. Going Direct',
  fel_comp_sub: 'With InnoFlex, the same price as just the e-CF gets you the complete system',
  fel_comp_col1: 'e-CF Direct',
  fel_comp_col1_sub: 'Only with RepublicaFEL',
  fel_comp_col2: 'e-CF via InnoFlex',
  fel_comp_col2_sub: 'Certification + support',
  fel_comp_col3: 'Full Bundle',
  fel_comp_col3_sub: 'System + e-CF + portal',
  fel_comp_best: 'Best Value',
  fel_comp_save_150: 'Save $150',
  fel_comp_save_200: 'Save $200',
  fel_comp_note: 'vs. setup + direct e-CF = $650',
  fel_comp_f1: 'DGII e-CF Certification',
  fel_comp_f2: 'RepublicaFEL Portal',
  fel_comp_f3: 'Activation support',
  fel_comp_f4: 'ERP · POS · Accounting System',
  fel_comp_f5: 'Setup included',
  fel_comp_f6: 'Team training',
  fel_comp_total: 'Total price',
  fel_comp_cta2: 'e-CF only',
  fel_comp_cta3: 'Get the Bundle',
  partners_bundle_label: 'InnoFlex + RepublicaFEL Bundle',
  partners_bundle_desc: 'Complete management system + e-CF certification ($250 in bundle, vs $300 standalone) + RepublicaFEL portal. Save $200 vs. buying everything separately.',
  partners_bundle_price: '$450',
  partners_bundle_note: 'One-time payment · Plus your chosen monthly plan',
  partners_bundle_cta: 'Get the Full Bundle',
  partners_addon_impl: 'Implementation',
  partners_addon_impl_price: '$200',
  partners_addon_impl_note: 'One-time · Included in bundle',
  partners_addon_fel: 'e-CF Certification',
  partners_addon_fel_price: '$300',
  partners_addon_fel_note: 'One-time · $150 less than direct activation',
  // Pricing FEL Addons
  pricing_addons_title: 'Implementation Services',
  pricing_addons_sub: 'One-time payments added to your monthly plan. Choose what you need.',
  pricing_addon1_title: 'Standard Setup',
  pricing_addon1_desc: 'System installation, configuration and initial training for your team.',
  pricing_addon1_price: '$200',
  pricing_addon1_badge: 'Required',
  pricing_addon2_title: 'e-CF Certification',
  pricing_addon2_desc: 'Certified e-CF billing via InnoFlex + RepublicaFEL. Save $150 vs. contracting directly with RepublicaFEL ($450).',
  pricing_addon2_price: '+$300',
  pricing_addon2_badge: 'Optional',
  pricing_addon3_title: 'Full Bundle',
  pricing_addon3_desc: 'Setup ($200) + e-CF Certification ($250) + RepublicaFEL Portal. e-CF drops from $300 to $250 inside the bundle.',
  pricing_addon3_price: '$450',
  pricing_addon3_badge: 'Best Value',
  pricing_addon3_savings: 'Save $200 vs. setup + direct e-CF ($650)',
  pricing_addons_note: 'All setup payments are one-time only. Monthly plan is billed separately.',
  // Services Software Section (ERP/POS/Accounting)
  sw_label: 'Management System',
  sw_title_1: 'ERP · POS ·',
  sw_title_accent: 'Accounting',
  sw_title_2: 'all in one',
  sw_cycle_2: 'for your business',
  sw_cycle_3: 'always available',
  sw_sub: 'A complete system that replaces spreadsheets, manual registers and paper records. Run your entire business from a single platform.',
  sw_keyword_erp: 'ERP',
  sw_keyword_pos: 'POS',
  sw_keyword_conta: 'Accounting',
  sw_keyword_inv: 'Inventory',
  sw_keyword_fel: 'e-CF Billing',
  sw_keyword_multi: 'Multi-Branch',
  sw_keyword_offline: 'Works Offline',
  sw_mod_pos_title: 'Point of Sale (POS)',
  sw_mod_pos_sub: 'Fast, accurate checkouts — no errors',
  sw_mod_pos_f1: 'Multiple cash registers',
  sw_mod_pos_f2: 'Employee shift control',
  sw_mod_pos_f3: 'Automatic end-of-day closing',
  sw_mod_pos_f4: 'Works without internet',
  sw_mod_erp_title: 'ERP — Business Management',
  sw_mod_erp_sub: 'The brain of your entire operation',
  sw_mod_erp_f1: 'Purchases and supplier control',
  sw_mod_erp_f2: 'Real-time inventory',
  sw_mod_erp_f3: 'Advanced financial reports',
  sw_mod_erp_f4: 'Multi-branch management',
  sw_mod_conta_title: 'Accounting & Finance',
  sw_mod_conta_sub: 'Your numbers always clear and up to date',
  sw_mod_conta_f1: 'Automatic P&L — no accountant needed',
  sw_mod_conta_f2: 'Real-time cash flow',
  sw_mod_conta_f3: 'Expense and profit control',
  sw_mod_conta_f4: 'Access from phone or PC',
  sw_mod_fel_title: 'Electronic Billing e-CF',
  sw_mod_fel_sub: 'DGII Certified · RepublicaFEL Portal',
  sw_mod_fel_f1: 'e-CF generated per sale',
  sw_mod_fel_f2: 'Credit and debit notes',
  sw_mod_fel_f3: 'Integrated RepublicaFEL portal',
  sw_mod_fel_f4: 'Certification via InnoFlex — save $150',
  sw_cta_heading: 'Ready to digitalize your business?',
  sw_cta_desc: 'ERP, POS and Accounting configured and live in 48 hours. Our team handles the entire setup for you.',
  sw_cta_plans: 'View Plans & Pricing',
  sw_cta_ask: 'Talk to an Advisor',
  // Digital Services Section
  digital_label: 'Digital Services',
  digital_title_1: 'Apps, Websites &',
  digital_title_accent: 'Custom Development',
  digital_sub: 'Beyond the management system — we design and build any digital solution your business needs.',
  digital_p1_title: 'Mobile Apps',
  digital_p1_sub: 'iOS and Android applications built from scratch for your business',
  digital_p1_f1: 'Modern custom UX/UI design',
  digital_p1_f2: 'Integration with APIs and existing systems',
  digital_p1_f3: 'App Store & Google Play publishing',
  digital_p1_f4: 'Scalable, secure cloud backend',
  digital_p1_for: 'Technologies:',
  digital_p1_tag1: 'iOS & Android',
  digital_p1_tag2: 'React Native',
  digital_p1_tag3: 'Flutter',
  digital_p2_title: 'Websites',
  digital_p2_sub: 'Professional digital presence that turns visitors into real customers',
  digital_p2_f1: 'Modern responsive custom design',
  digital_p2_f2: 'Landing pages, corporate sites & e-commerce',
  digital_p2_f3: 'SEO-optimized from the start',
  digital_p2_f4: 'Speed, hosting and domain managed',
  digital_p2_for: 'Types:',
  digital_p2_tag1: 'Landing Pages',
  digital_p2_tag2: 'E-commerce',
  digital_p2_tag3: 'Portfolios',
  digital_p3_title: 'Design & Software',
  digital_p3_sub: 'Internal systems, platforms and custom software for any industry',
  digital_p3_f1: 'Internal systems and dashboards',
  digital_p3_f2: 'External API integrations',
  digital_p3_f3: 'Automations and workflows',
  digital_p3_f4: 'Professional UI/UX design',
  digital_p3_for: 'For:',
  digital_p3_tag1: 'Startups',
  digital_p3_tag2: 'SMBs',
  digital_p3_tag3: 'Enterprises',
  digital_p4_title: 'Consulting',
  digital_p4_sub: 'Technology strategy to digitalize and scale your business',
  digital_p4_f1: 'Full audit of processes and systems',
  digital_p4_f2: 'Personalized digitalization roadmap',
  digital_p4_f3: 'Tool selection and integration',
  digital_p4_f4: 'Post-project support and follow-up',
  digital_p4_for: 'For:',
  digital_p4_tag1: 'Startups',
  digital_p4_tag2: 'SMBs',
  digital_p4_tag3: 'Enterprises',
  digital_cta_heading: 'Tell us your idea and we\'ll make it real',
  digital_cta_desc: 'Apps, websites, custom software or strategic consulting — we work with you from concept to launch.',
  digital_cta_ask: 'Talk to an Advisor',
  digital_cta_book: 'Book Your Free Appointment',
  plan_invoice_tooltip: 'Additional invoices beyond the monthly limit are billed separately as an add-on.',
  faq_f5_q: 'What happens if I exceed my plan\'s monthly invoice limit?',
  faq_f5_a: 'Invoices that exceed your plan\'s monthly limit are billed as a separate add-on through the e-CF service. You can contract it at any time from the pricing section or by contacting us on WhatsApp. Your service is never interrupted — it is simply managed as an additional charge.',
  faq_f6_q: 'How do I contract the e-CF e-invoicing system?',
  faq_f6_a: 'e-CF is contracted as an add-on independent from your monthly plan. The cost is $300 (one-time payment) and includes: RepublicaFEL portal activation, full DGII setup and activation support. If you combine it with implementation (Full Bundle), the total drops to $450, saving you $200 vs. contracting everything separately. Just contact us on WhatsApp to start the process.',
  faq_rfel6_q: 'How long does e-CF activation take?',
  faq_rfel6_a: 'Once you contract the e-CF add-on, activation takes 3 to 5 business days. During that time we handle the full DGII certification, configure your RepublicaFEL portal and connect it to your InnoFlex system. You just wait — we notify you on WhatsApp as soon as it is ready.',
  faq_rfel7_q: 'Can I add e-CF after my monthly plan is already active?',
  faq_rfel7_a: 'Yes, at any time. The e-CF add-on is completely independent from your monthly plan and can be contracted at any stage — at the start, months later, or whenever you need it. Just message us on WhatsApp and we will kick off the certification process without affecting your current service.',
};

export default translations;
